module.exports = __webpack_public_path__ + "media/moon_in_ones_cup.843cfb30.mp3";